export default "__VITE_ASSET__CFR9iLwO__"